import {useState, useCallback, useEffect, useContext} from 'react';
import {Routes, Route, useLocation, Navigate} from 'react-router-dom';
import {UserContext} from './contexts/UserContext';
// import { getAnalytics } from "firebase/analytics";

//Frontend
import Home from "./frontend/pages/Home";
// import About from "./frontend/pages/About";
// import Me from "./frontend/pages/Me";
// import Collabs from "./frontend/pages/Collabs";
// import Reviews from "./frontend/pages/Reviews";
import Paths from "./frontend/pages/Paths";
import PathsMedication from "./frontend/pages/PathsMedication";
import PathsTrailerLoading from "./frontend/pages/PathsTrailerLoading";
import PathsDressageBasic from "./frontend/pages/PathsDressageBasic";
import PathsOutdoorExcursion from "./frontend/pages/PathsOutdoorExcursion";
import PathsMockExcursion from "./frontend/pages/PathsMockExcursion";
import Activities from "./frontend/pages/Activities";
// import Disciplines from "./frontend/pages/Disciplines";
// import Services from "./frontend/pages/Services";
// import ServicesConsulting from "./frontend/pages/ServicesConsulting";
// import ServicesHoofCare from "./frontend/pages/ServicesHoofCare";
// import ServicesIntroductions from "./frontend/pages/ServicesIntroductions";
// import ServicesEthicalHorsemanship from "./frontend/pages/ServicesEthicalHorsemanship";
// import BlogList from "./frontend/pages/BlogList";
// import BlogSingle from "./frontend/pages/BlogSingle";
import Contacts from "./frontend/pages/Contacts";

//Authentication
// import Registration from "./backend/pages/Registration";
import Login from "./backend/pages/Login";

//Backend
import AdminDashboard from './backend/pages/Dashboard';
import AdminHorsesList from './backend/pages/HorsesList';
import AdminHorsesSingle from './backend/pages/HorsesSingle';
import AdminMembershipsList from './backend/pages/MembershipsList';
import AdminMembershipsSingle from './backend/pages/MembershipsSingle';

//404
import NotFound from "./frontend/pages/NotFound";

import {BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XS, LAYOUT_LG, LAYOUT_MD, LAYOUT_SM, LAYOUT_XS } from './config';

const RequireAuth = ({children}: {children: JSX.Element}) => {
  const {user} = useContext(UserContext);
  let location = useLocation();
  // console.log(user);
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return (<>{children}</>);
}

const App = () => {
  const [resizeListener, setResizeListener] = useState(false);
  const [layout, setLayout] = useState(null);

  // useEffect(() => {
  //   AnalyticsService.getUrl(src).then((response) => {
  //     if(response.success){
  //       setUrl(response.url);
  //     }else{
  //       console.log(response.error);
  //     }
  //   });
  // }, []);

  const handleResize = useCallback(() => {
    setLayout(window.innerWidth <= BREAKPOINT_XS ? LAYOUT_XS : (window.innerWidth <= BREAKPOINT_SM ? LAYOUT_SM : (window.innerWidth <= BREAKPOINT_MD ? LAYOUT_MD : LAYOUT_LG)));
  }, []);

  useEffect(() => {
    if(!resizeListener){
      setResizeListener(true);
      window.addEventListener("resize", handleResize, false);
      handleResize();
    }
  }, [handleResize, resizeListener]);

  return (
    <Routes>

      {/*Frontend*/}
      <Route exact path='/' element={<Home layout={layout} />} />


      {/* <Route exact path='/about' element={<About layout={layout} />} />
      <Route exact path='/about/me' element={<Me layout={layout} />} />
      <Route exact path='/about/collabs' element={<Collabs layout={layout} />} />
      <Route exact path='/about/reviews' element={<Reviews layout={layout} />} /> */}
      
      <Route exact path='/percorsi' element={<Paths layout={layout} />} />
      <Route exact path='/percorsi/medicazioni' element={<PathsMedication layout={layout} />} />
      <Route exact path='/percorsi/trailer-loading' element={<PathsTrailerLoading layout={layout} />} />
      <Route exact path='/percorsi/dressage' element={<PathsDressageBasic layout={layout} />} />
      <Route exact path='/percorsi/escursione-esterna' element={<PathsOutdoorExcursion layout={layout} />} />
      <Route exact path='/percorsi/escursione-simulata' element={<PathsMockExcursion layout={layout} />} />
      
      <Route exact path='/attivita' element={<Activities layout={layout} />} />
      {/* <Route exact path='/attivita/paths' element={<Paths layout={layout} />} />
      <Route exact path='/attivita/disciplines' element={<Disciplines layout={layout} />} /> */}

      {/* <Route exact path='/servizi' element={<Services layout={layout} />} />
      <Route exact path='/servizi/consulting' element={<ServicesConsulting layout={layout} />} />
      <Route exact path='/servizi/hoof-care' element={<ServicesHoofCare layout={layout} />} />
      <Route exact path='/servizi/introductions' element={<ServicesIntroductions layout={layout} />} />
      <Route exact path='/servizi/ethical-horsemanship' element={<ServicesEthicalHorsemanship layout={layout} />} />
      */}

      
      <Route exact path='/contatti' element={<Contacts layout={layout} />} />
    
  
      {/*Authentication*/}
      <Route exact path='/admin/login' element={<Login />} />

      {/*Backend*/}
      <Route exact path='/admin' element={<RequireAuth><AdminDashboard layout={layout} /></RequireAuth>} />
      <Route exact path='/admin/horses' element={<RequireAuth><AdminHorsesList layout={layout} /></RequireAuth>} />
      <Route exact path="/admin/horses/:slug" element={<RequireAuth><AdminHorsesSingle layout={layout} /></RequireAuth>} />
      <Route exact path='/admin/memberships' element={<RequireAuth><AdminMembershipsList layout={layout} /></RequireAuth>} />
      <Route exact path="/admin/memberships/:slug" element={<RequireAuth><AdminMembershipsSingle layout={layout} /></RequireAuth>} />
     
      {/*404*/}
      <Route path='/undefined/*' element={<Navigate to={"/it"} />}  />
      <Route path='*' element={<NotFound layout={layout} />} />
    </Routes>
  );
}

export default App;
